import DualInfoArea from "@core-components/info-area/DualInfoArea";
import type { IInfoAreaProps } from "@core-components/info-area/InfoArea";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Trans } from "react-i18next";
import ValorantInfoAreaHeadline from "./ValorantInfoAreaHeadline";

const ValorantDualInfoAreaQuestions = () => {
  const { t } = useAppTranslation("pages.valorant.dualInfoAreaQuestions");
  const areaClassName =
    "text-[18px] reset-tailwind text-primary-white px-2 xl:px-5 py-8";

  const leftArea: IInfoAreaProps = {
    description: (
      <div className={areaClassName}>
        <Trans
          t={t}
          i18nKey="left.content"
          components={[
            <strong key="0" />,
            <span className="leading-7" key="3" />,
            <span className="leading-7" key="6" />,
            <span className="leading-7" key="10" />,
            <span className="leading-7" key="13" />,
          ]}
        />
      </div>
    ),
    headLine: (
      <ValorantInfoAreaHeadline>{t("left.headline")}</ValorantInfoAreaHeadline>
    ),
  };
  const rightArea: IInfoAreaProps = {
    description: (
      <div className={areaClassName}>
        <h3 className="m-0 text-xl">
          💬 <strong>{t("right.questions.legal.title")}</strong>
        </h3>
        <br />
        <p>{t("right.questions.legal.answer")}</p>
        <br />

        <h3 className="m-0 text-xl">
          💬 <strong>{t("right.questions.advantages.title")}</strong>
        </h3>
        <br />
        <p>{t("right.questions.advantages.answer")}</p>
        <br />
        <h3 className="m-0 text-xl">
          💬 <strong>{t("right.questions.difference.title")}</strong>
        </h3>
        <br />
        <p>{t("right.questions.difference.answer")}</p>
      </div>
    ),
    headLine: (
      <ValorantInfoAreaHeadline>{t("right.headline")}</ValorantInfoAreaHeadline>
    ),
  };

  return (
    <DualInfoArea className="gap-6" leftArea={leftArea} rightArea={rightArea} />
  );
};

export default ValorantDualInfoAreaQuestions;
